import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1PositionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class PositionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.Position-001";

        let QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "Position": {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }
        let queryPayload = this.prepareQueryPayload();

        if (queryPayload.size > 0) {
            for (const [key, value] of queryPayload) {
                if (key.includes("_query")) continue;

                let operator = "EQUAL";
                if (queryPayload.get(key + "_query") !== undefined) {
                    operator = queryPayload.get(key + "_query")
                }
                QBE.PlatformMessage.Position.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": value,
                    "Operator": operator
                })
            }
        }

        // Declarative picklist filters (e.g. PositionShared restricts to FocusArea = "Data Catalog")
        // are carried as the EC's searchSpecification (set by PlatformSelect) and emitted as EQUAL QBE
        // members. Empty {} for the unrestricted callers, so this is a no-op unless a filter is set.
        let searchSpecification = this.getSearchSpecification();
        if (searchSpecification) {
            for (const key of Object.keys(searchSpecification)) {
                QBE.PlatformMessage.Position.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute", "Name": key, "Value": searchSpecification[key], "Operator": "EQUAL"
                })
            }
        }

        // THE READ COMES FROM t1, the writes below still go to t6.
        //
        // Every read in t6's Administration application requires the administrator privilege, and
        // this component backs the POSITION PICKERS -- including the one on the Stewardship tab
        // where a record is shared. The rule agreed this week is that any member of the owning
        // position may share it; the picker demanded administrator, so the relaxation was unusable
        // by exactly the people it was for.
        //
        // Creating, renaming or deleting a position is administration and is unchanged: those calls
        // below still go to t6, where they are gated, and where they belong.
        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/positions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1PositionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let adminPosition = {};

        adminPosition["USID"] = this.getAttributeValue("USID");
        adminPosition["Name"] = this.getAttributeValue("Name");
        adminPosition["OrganizationUSID"] = this.getAttributeValue("OrganizationUSID");
        adminPosition["ParentUSID"] = this.getAttributeValue("ParentUSID");
        adminPosition["PrimaryAccountUserUSID"] = this.getAttributeValue("PrimaryAccountUserUSID");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Position-001";
        payload.PlatformMessage.Position = adminPosition;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t6/v1/positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Position-001",
                "idoc-response": "v1.Position-001"
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1PositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Position-001";
        payload.PlatformMessage.Position = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Position-001",
                "idoc-response": "v1.Position-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1PositionIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Position-001";
        payload.PlatformMessage.Position = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t6/v1/positions",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Position-001",
                "idoc-response": "v1.Position-001",
            },
        };
        this.notifyDeleteStartListeners();
        AxiosAdminAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default PositionEnterpriseComponent;